// Update to your App.js to add the session listener
import React from 'react';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import LoginPage from './components/LoginPage';
import ExplorePage from './components/ExplorePage';
import ProtectedRoute from './components/ProtectedRoute';
import CatalogImagery from './components/CatalogImagery';
import CheckoutPage from './components/CheckoutPage';
import OrderPage from './components/OrderPage';
import SettingsPage from './components/SettingsPage';
import TestPage from './components/TestPage';
import DataDeliveryPage from './components/DataDeliveryPage';
import ProductDetailPage from './components/ProductDetailPage';
import ProductCatalog from './components/ProductCatalog';
import ProfilePage from './components/ProfilePage';
import SessionListener from './components/SessionListener'; // Import the session listener
import ProductDetailOPT70 from './components/ProductDetailOPT70'
import DocumentationRoutes from './components/DocumentationRoutes';
import ProductDetailSentinel2 from './components/ProductDetailSentinel2';
import ProductDetailLandsat8_9 from './components/ProductDetailLandsat_8_9';
import AnalyticsProductNDVISentinel2 from './components/AnalyticsProductNDVISentinel2';
import AnalyticsProductNDWISentinel2 from './components/AnalyticsProductNDWISentinel2';


// Layout component that includes the header
const Layout = ({ children }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  const landingpage = location.pathname === '/';

  return (
    <div className="h-screen flex flex-col bg-black">
      {/* Conditionally render navbar */}
      {!isLoginPage && !landingpage && <Navbar className="flex-none" />}
      {/* Main content that takes up all remaining space */}
      <main className="flex-1 overflow-hidden">
        {children}
      </main>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      {/* Add the SessionListener component */}
      <SessionListener />
      
      <Layout>
        <Switch>
          <Route exact path="/login" component={LoginPage} />
          <ProtectedRoute exact path="/" component={LoginPage} />
          <ProtectedRoute path="/explore" component={ExplorePage} />
          <ProtectedRoute path="/checkout" component={CheckoutPage} />
          <ProtectedRoute path='/orders' component={OrderPage} />
          <ProtectedRoute path='/settings' component={SettingsPage} />
          <ProtectedRoute path='/test' component={TestPage} />
          <ProtectedRoute path='/delivery/:orderId' component={DataDeliveryPage} />
          <ProtectedRoute exact path='/products' component={ProductCatalog} />
          <ProtectedRoute path='/products/OPT-120' component={ProductDetailPage} />
          <ProtectedRoute path='/products/OPT-70' component={ProductDetailOPT70} />
          <ProtectedRoute path='/products/Sentinel-2' component={ProductDetailSentinel2}/>
          <ProtectedRoute path='/products/Landsat-8-9' component={ProductDetailLandsat8_9}/>
          <ProtectedRoute path='/products/ndvi_s2' component={AnalyticsProductNDVISentinel2}/>
          <ProtectedRoute path='/products/ndwi_s2' component={AnalyticsProductNDWISentinel2}/>
          <ProtectedRoute path='/settings/profile' component={ProfilePage} />
          <ProtectedRoute path="/documentation" component={DocumentationRoutes}/>

        </Switch>
      </Layout>
    </Router>
  );
};

export default App;